var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgEmailClosed = function SvgEmailClosed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-info-200)",
    d: "M46.933 14.688H17.067c-3.535 0-6.4 2.956-6.4 6.603v22.01c0 3.647 2.865 6.604 6.4 6.604h29.866c3.535 0 6.4-2.957 6.4-6.603V21.29c0-3.647-2.865-6.603-6.4-6.603zm-.874 4.402L33.515 32.032a2.1 2.1 0 0 1-1.515.651 2.1 2.1 0 0 1-1.515-.65L17.941 19.09H46.06zm3.008 24.212c0 1.215-.955 2.2-2.134 2.2H17.067c-1.179 0-2.134-.985-2.134-2.2V22.193l12.544 12.943a6.262 6.262 0 0 0 9.046 0l12.544-12.943v21.109z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailClosed);
export default ForwardRef;